import { Injectable, NgZone } from '@angular/core';
import { JwtService } from './jwt.service';
import { MyprofileService } from './myprofile.service';
import { CartService } from './cart.service';
import { AppConstants } from 'src/app/app.constants';
import { CommunicationService } from './communication.service';
import { OrdermapService } from './ordermap.service';
import { LoginService } from './login.service';
import { Router } from '@angular/router';
import { LoginRequestPostDataInterface } from '../interfaces/request-interfaces/signup.interface';
import { firstValueFrom } from 'rxjs';
import { BrowserService } from 'src/_lib/service/browser.service';

@Injectable({
  providedIn: 'root',
})
export class CustomerLoginService {
  constructor(
    private loginService: LoginService,
    private loginhttp: OrdermapService,
    private router: Router,
    private jwtService: JwtService,
    private comm: CommunicationService,
    private appConstants: AppConstants,
    private cartHttp: CartService,
    private myprofileHttp: MyprofileService,
    private zone: NgZone,
    private browser: BrowserService
  ) { }

  firstObj = this.appConstants.firstObj;
  totalItems: number;
  loginError: number = 0;

  async getCustomerLogin(
    userData: LoginRequestPostDataInterface
  ): Promise<any> {
    try {
      const response = await firstValueFrom(this.loginService.login(userData));
      if (response.success) {
        this.browser.localStorage?.setItem('useOfTerms', response.customer_info.use_of_terms);
        this.browser.localStorage?.setItem(
          'dealerTerms',
          response.customer_info.dealer_terms
        );
        this.browser.localStorage?.setItem(
          'priceLevels',
          response.customer_info.price_levels
        );
        this.browser.localStorage?.setItem('UserToken', response.token);
        this.browser.localStorage?.setItem('Username', response.customer_info.first_name);
        this.comm.setUsername(response.customer_info.first_name);
        this.comm.usernameSubject.next(true);
        this.comm.userNameValueSubject.next(response.customer_info.first_name);
        this.browser.localStorage?.setItem('email', response.customer_info.email_address);
        this.comm.usernameSubject.next(true);
        this.loginService.setUserLoggedIn(true);
        await this.handleOrderAndRedirect();
        await this.loadWishlistItems();
        if (this.router.url !== '/cart') {
          this.loadCartProducts();
        }
        if (response.customer_info?.is_carporate === 'yes') {
          this.browser.localStorage?.setItem('isCorporateUser', 'true');
          this.comm.setIsCorporateUser(true);
        } else {
          this.browser.localStorage?.setItem('isCorporateUser', 'false');
          this.comm.setIsCorporateUser(false);
        }
        return 0;
      } else {
        console.error('Login failed:', response);
        return 1;
      }
    } catch (error) {
      console.error('API Error: ', error);
      return 1;
    }
  }

  redirectAfterLogin() {
    const redirectUrl = this.browser.localStorage?.getItem('redirectAfterLogin');
    const customerLoginUrl = '/customer-login';
    if (redirectUrl) {
      this.browser.localStorage?.removeItem('page');
        if (redirectUrl === customerLoginUrl) {
        this.router.navigate(['/'], { replaceUrl: true });
      } else if (redirectUrl == '/checkout') {
        this.router.navigate([redirectUrl]);
      } else {
        this.zone.run(() => {
          this.router.navigate(['/my-account']);
        });
      }
    } else {
      this.router.navigate(['/'], { replaceUrl: true });
    }
  }

  async handleOrderAndRedirect() {
    const orderId = this.browser.localStorage?.getItem('orderId');
    if (orderId) {
      const reorderData = {
        merge_order: orderId,
      };
      try {
        const reorderResponse = await this.loginhttp
          .cartReorder(reorderData)
          .toPromise();
        const newOrderId = reorderResponse[0]?.data.order_key;
        if (newOrderId) {
          this.browser.localStorage?.setItem('orderId', newOrderId);
        } else {
          console.error('New order ID not found in the response');
        }
      } catch (err) {
        console.error('Cart reorder failed:', err);
      }
    }
    this.browser.localStorage?.getItem('page');
    this.closePopup();
  }
  
  async loadWishlistItems() {
    const token: any = this.jwtService.getTokenFromLocalStorage();
    if (token) {
      this.myprofileHttp.getSaveForLaterproducts(token).subscribe({
        next: (response: any) => {
          if (response[this.firstObj]?.success === true) {
            const mywishlistdata = response[0]?.data || [];
            const wishlistItem = mywishlistdata?.length;
            this.browser.localStorage?.setItem('wishlistItem', String(wishlistItem));
            this.comm.setCount(wishlistItem);
          } else {
            this.browser.localStorage?.setItem('wishlistItem', '0');
            this.comm.setCount(0);
          }
        },
        error: (error: Error) => {
          console.error(
            'Custom Error: Unexpected Error while fetching user wishlist data:',
            error
          );
        },
      });
    }
  }

  loadCartProducts() {
    this.totalItems = 0;
    const token = this.browser.localStorage?.getItem('UserToken');
    this.redirectAfterLogin();
    this.loginService.loadUserCartproduct(token).subscribe({
      next: (response) => {
        if (response[this.firstObj].success == true) {
          response[this.firstObj]?.data?.order_items.map(
            (item: { qty: number }) => {
              this.totalItems = this.totalItems + Number(item.qty);
            }
          );
          const orderItemsData =
            response?.[this.firstObj]?.data?.order_items || [];
          orderItemsData.forEach((item) => {
            this.cartHttp.setOrderItemsList(
              item.product_variation_key,
              item.qty
            );
          });
          this.cartHttp.setLocalStorageOrderItemsList();
          this.browser.localStorage?.setItem('ItemCount', String(this.totalItems));
          this.comm.itemCount.next(null);
          this.browser.localStorage?.setItem(
            'orderId',
            response[this.firstObj]?.data?.order_key
          );
          const orderItems = response[this.firstObj]?.data?.order_items;
          if (orderItems?.length) {
            this.cartHttp.setCartShippingType(response[this.firstObj]?.data?.is_freight_shipping == 1);
          } else {
            this.cartHttp.clearCartShippingType();
          }
          this.comm.emitCartItemRemoved(true);
        }
      },
      error: (error) => {
        console.error('Error loading cart products:', error);
        this.redirectAfterLogin();
      },
    });
  }

  closePopup() {
    this.browser.localStorage?.removeItem('page');
    this.comm.closedDialog$.next(true);
  }
}